<!-- Flat card: every part is a direct grid child of .ws-product-card (layout in styles/themable/_product-card.scss). -->
<div class="ws-product-card ws-product-card--complex"
     [ngClass]="cardClasses()"
     [class.ws-product-card--controls-visible]="controlsVisible()"
     [class.ws-product-card--touch-locked]="touchLocked()"
     (click)="onCardClick($event)">
  <ng-container *ngTemplateOutlet="blocks().media"></ng-container>
  <ng-container *ngTemplateOutlet="blocks().badges"></ng-container>
  <ng-container *ngTemplateOutlet="blocks().cartCount"></ng-container>
  <ng-container *ngTemplateOutlet="blocks().buy"></ng-container>

  <div class="ws-product-card__touch-area ws-product-card__media-part"></div>

  @if (!cartCount()) {
    <button class="btn ws-button ws-button--primary ws-product-card__buy ws-product-card__buy--overlay ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-touch"
            [translate]="'orderProcess.cakesOverview.cakeItem.buy'"
            (click)="open.emit()">Buy
    </button>

    <!-- desktop only -->
    <div class="ws-product-card__overlay-panel ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"></div>

    <a class="ws-product-card__overlay-link ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
       [routerLink]="builderLink()?.link"
       [queryParams]="builderLink()?.queryParams"></a>

    <div class="h4 text-center px-2 ws-product-card__overlay-title ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop">
      {{ cake().name }}
    </div>

    @if (cake().sizesCount) {
      <div class="font-xl fw-bold ws-product-card__overlay-text ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop">
        {{ 'orderProcess.cakesOverview.cakeItem.availableSizesCount' | translate: { count: cake().sizesCount } }}
      </div>
    }

    @if (cake().canHasMotive) {
      <div class="align-items-center ws-product-card__overlay-feature ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop">
        <i class="icon-account-box me-2 ws-product-card__overlay-feature-icon"></i>
        <span class="font-md"
              [translate]="'orderProcess.cakesOverview.cakeItem.canHavePhoto'">Can have photo on</span>
      </div>
    }

    <a class="btn ws-button ws-button--primary btn-long ws-product-card__overlay-cta ws-product-card__overlay-cta--passive ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
       [routerLink]="builderLink()?.link"
       [queryParams]="builderLink()?.queryParams"
       [translate]="'common.orderNow'">
      View
    </a>
  } @else {
    <!-- in the cart: clicks on the overlay stay here (the old panel stopped them) -->
    <div class="ws-product-card__overlay-panel ws-product-card__overlay-part ws-product-card__media-part"
         (click)="$event.stopPropagation()"></div>

    <a class="ws-product-card__overlay-link ws-product-card__overlay-part ws-product-card__media-part"
       [routerLink]="builderLink()?.link"
       [queryParams]="builderLink()?.queryParams"
       (click)="$event.stopPropagation()"></a>

    <div class="font-xl fw-bold text-center ws-product-card__overlay-text ws-product-card__overlay-part ws-product-card__media-part"
         [translate]="'orderProcess.cakesOverview.cakeItem.productExistInCart'"
         (click)="$event.stopPropagation()">
      You already have this product in cart
    </div>

    <div class="text-center ws-product-card__overlay-actions ws-product-card__overlay-part ws-product-card__media-part"
         (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-between">
        <button class="btn ws-button ws-button--secondary ws-product-card__cart-action ws-product-card__cart-action--edit ws-product-card__overlay-action"
                [translate]="'orderProcess.cakesOverview.cakeItem.editExisting'"
                (click)="$event.stopPropagation(); edit.emit()">
          Edit
        </button>

        <a class="btn ws-button ws-button--secondary ws-product-card__cart-action ws-product-card__cart-action--add ws-product-card__overlay-action"
           [routerLink]="builderLink()?.link"
           [queryParams]="builderLink()?.queryParams"
           [translate]="'orderProcess.cakesOverview.cakeItem.addNew'">
          Add new
        </a>
      </div>

      <button class="btn ws-button ws-button--danger ws-product-card__cart-action ws-product-card__cart-action--remove ws-product-card__overlay-action"
              [translate]="'orderProcess.cakesOverview.cakeItem.removeFromCart'"
              (click)="$event.stopPropagation(); remove.emit()">
        Remove from the cart
      </button>
    </div>
  }

  <ng-container *ngTemplateOutlet="blocks().footer"></ng-container>
</div>
